<!-- Test-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Test Navigation Child</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <!-- URL Parameters Test Card -->
    <cs-card>
      <cs-card-header>URL Parameters (Manual Update)</cs-card-header>
      <cs-card-content>
        <cs-item-list>
          <cs-item>
            <cs-label>Current URL:</cs-label>
            <cs-label class="mono">{{ currentUrl }}</cs-label>
          </cs-item>
          <cs-item vertical>
            <cs-label>Mode:</cs-label>
            <cs-input [(value)]="modeValue" [placeholder]="'Enter mode value' | untranslated" data-test="mode-input">
            </cs-input>
          </cs-item>
          <cs-item vertical>
            <cs-label>Filter:</cs-label>
            <cs-input [(value)]="filterValue" [placeholder]="'Enter filter value' | untranslated" data-test="filter-input">
            </cs-input>
          </cs-item>
          <cs-item vertical>
            <cs-label>Debug:</cs-label>
            <cs-input [(value)]="debugValue" [placeholder]="'Enter debug value' | untranslated" data-test="debug-input">
            </cs-input>
          </cs-item>
          <cs-item>
            <cs-button item-right (click)="updateUrlParams()" [label]="'Update URL' | untranslated"
              data-test="update-url-button" fit-width>
            </cs-button>
          </cs-item>
          <cs-item>
            <cs-button item-right (click)="navigateBackToParent()" [label]="'Back to Parent' | untranslated"
              data-test="back-to-parent" fit-width>
            </cs-button>
          </cs-item>
        </cs-item-list>
      </cs-card-content>
    </cs-card>
  </cs-card-list>

</cs-content>
